import { num } from '../../scene/component-types.js';
import type { SettingsSection } from '../settings-types.js';

/** `settings.audio` (prism_core::audio::AudioSettings); see engine/docs/systems/audio.md. */
const audio: SettingsSection = {
  key: 'audio',
  label: 'Audio',
  icon: 'audio',
  order: 40,
  hint: 'Mixer, voice limit, global volume, doppler',
  fields: [
    {
      key: 'mixer',
      label: 'Mixer',
      type: { kind: 'path', suffix: '.mixer.json' },
      hint: 'audio mixer asset (buses + snapshots); empty = only the Master bus',
    },
    { key: 'globalVolume', label: 'Global volume', type: num(0.05, { min: 0, max: 1 }), read: () => 1 },
    {
      key: 'maxVoices',
      label: 'Max voices',
      type: num(1, { min: 1, max: 255, integer: true }),
      read: () => 32,
      hint: 'sounds at once; above this the least important (audioSource priority) stop',
    },
    { key: 'dopplerFactor', label: 'Doppler factor', type: num(0.1, { min: 0, max: 10 }), read: () => 1, hint: '0 = no doppler' },
    { key: 'speedOfSound', label: 'Speed of sound', type: num(1, { min: 1 }), read: () => 343, hint: 'meters per second' },
    {
      key: 'pauseOnTimeScaleZero',
      label: 'Pause at time scale 0',
      type: { kind: 'bool' },
      read: () => true,
      hint: 'sources pause while the game is paused, except ones with Ignore Pause',
    },
    {
      key: 'maxStartDelay',
      label: 'Max start delay',
      type: num(0.05, { min: 0, max: 60 }),
      read: () => 0.5,
      hint: 'seconds a non-looping sound may wait for its clip to load before it is skipped (0 = always play)',
    },
  ],
};

export default audio;
